import { render, staticRenderFns } from "./jxsqForm.vue?vue&type=template&id=64221ac6&scoped=true&"
import script from "./jxsqForm.vue?vue&type=script&lang=js&"
export * from "./jxsqForm.vue?vue&type=script&lang=js&"
import style0 from "./jxsqForm.vue?vue&type=style&index=0&id=64221ac6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64221ac6",
  null
  
)

export default component.exports